module.exports = __webpack_public_path__ + "static/img/bg_4.8f396b1e.png";